<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>
<script>
import store from './store';
import { getURLParameter } from './utils/index.js';
export default {
    data() {
        return {};
    },
    created() {
        sessionStorage.setItem('firstUpdata', true);
        store.commit('SET_LOCATION_SELECTION_OBJ', null);
        store.commit('SET_IS_SHOW_DATA_COMPARE', false);
        store.commit('SET_SELECT_BRAND', '');
        if (window.self !== window.top) {
            this.getUrlToken();
        }
    },
    methods: {
        getUrlToken() {
            //获取url携带的token 这里用来接收url参数并重定向当前页面
            store.commit('SET_ACCESS_TOKEN', getURLParameter('token'));
            store.commit('SET_MERCHANT_ID', getURLParameter('merchantId'));
            store.commit('SET_UID', getURLParameter('uid'));
            //重置扫码登录的标识
            store.commit('SET_SCAN_CODE_LOGIN_TYPE', false);
            this.$router.push(window.location.pathname);
        }
        
    }
};
</script>
<style lang="scss">
#app {
    height: 100%;
    background: #f7f8fa;
}
</style>
